import SourcesPage from "@app/pages/sources/sources-page";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";

export const Route = createFileRoute("/_authed/sources")({
  head: () => pageHead("Sources"),
  component: SourcesRoute,
});

function SourcesRoute() {
  return (
    <ErrorBoundary
      fallback={<div className="p-6 text-red-500">Error loading sources</div>}
    >
      <Suspense
        fallback={<div className="p-6 text-gray-500">Loading sources…</div>}
      >
        <SourcesPage />
      </Suspense>
    </ErrorBoundary>
  );
}
